export default __webpack_public_path__ + "static/media/applePay.44075819.svg";